import { createContext, useEffect, useState } from "react";
import * as signalR from "@microsoft/signalr";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import mqtt from "mqtt";

const DasboardContext = createContext();

const DashboardProvider = ({ children }) => {
  
  const [isLogin, setIsLogin] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [profileName, setProfileName] = useState();
  const [bedData, setBedData] = useState([]);
  const [states, setStates] = useState([]);
  const [events, setEvents] = useState([]);
  const [topic, setTopic] = useState();
  const [usernames, setUsernames] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [sameSuit, setSameSuit] = useState([]);
  const [filter, setFilter] = useState();
  const [vitalToken, setVitalToken] = useState();

  const [userInfo, setUserInfo] = useState({});

  const [checkedItems, setCheckedItems] = useState([]);

  //For SignalR
  const [devices, setDevices] = useState([]);
  const [connection, setConnection] = useState(null);
  const [messages, setMessages] = useState([]);
  const [battery, setBattery] = useState([]);
  const [vitalModal, setVitalModal] = useState(false);

  const [hobaModal, setHobaModa] = useState(false);
  const [hobaAlarm, setHobaAlarm] = useState(false);

  const [alarm, setAlarm] = useState([]);

  const [hobaData, setHobaData] = useState({}); // Cihaz ID'sine göre map: { [deviceId]: { payload: {...} } }

  let userInfoCompany;

  const addVayyarLog = async (deviceId, vayyarData, dataType) => {
    try {
      const response = await fetch(`https://app.vivasmartcare.com/api/vayyar-log`, {
        method: "POST",
        body: JSON.stringify({
          deviceId,
          vayyarData,
          dataType,
        }),
        headers: { "Content-Type": "application/json" },
      });
      console.log("Log eklendi");
    } catch (error) {
      console.error("Vayyar logu eklenirken bir hata oluştu:", error);
    }
  };

  const getUsernames = async () => {
    try {
      const response = await fetch(`https://app.vivasmartcare.com/api/usernames`);
      setUsernames(await response.json());
    } catch (error) {
      console.error("Error fetching device data:", error);
    }
  };

  async function sendSMS(targetNumbers, roomName, organization, suiteName) {
    try {
      const requests = targetNumbers.map((targetNumber) =>
        fetch("https://app.vivasmartcare.com/api/messages", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            targetNumber: targetNumber,
            roomName: roomName,
            organization: organization,
            suiteName: suiteName,
          }),
        })
      );

      const responses = await Promise.all(requests);

      responses.forEach((response, index) => {
        if (response.ok) {
          console.log(
            `Mesaj ${targetNumbers[index]} numarasına başarıyla gönderildi`
          );
        } else {
          console.error(
            `HTTP Hatası ${targetNumbers[index]} için:`,
            response.status
          );
        }
      });
    } catch (error) {
      console.error("Bir hata oluştu:", error);
    }
  }

  async function addAlarmLog({
    deviceId,
    endTimestamp,
    eventType,
    resolved,
    callCount,
    confirmation,
    description,
    alarmScenario,
    person,
  }) {
    try {
      const response = await fetch("https://app.vivasmartcare.com/api/log-add", {
        method: "POST",
        body: JSON.stringify({
          deviceId,
          endTimestamp,
          eventType,
          resolved,
          callCount,
          confirmation,
          description,
          alarmScenario,
          person,
        }),
        headers: { "Content-Type": "application/json" },
      });

      if (response.ok) {
        console.log("Alarm başarıyla eklendi", response);
      } else {
        console.log("Alarm eklenirken bir hata oluştu");
      }
    } catch (error) {
      console.error(
        "Alarm log ekleme işlemi sırasında bir hata oluştu:",
        error
      );
    }
  }

  const fetchUserInfo = async () => {
      try {
      // Yeni endpoint cookie'den token alıyor (httpOnly cookie otomatik gönderilir)
      const response = await fetch(`https://app.vivasmartcare.com/api/profile`, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });

        if (!response.ok) {
        // Token yoksa veya geçersizse
        setUserInfo({});
        return null;
        }

        const userInfo = await response.json();
        setUserInfo(userInfo);
        return userInfo;
      } catch (error) {
        console.error("Failed to fetch user info:", error);
      setUserInfo({});
        return null;
      }
  };

  const getDevices = async (userInfoParam = null) => {
    try {
      // Parametre olarak gelen userInfo'yu kullan, yoksa state'ten al
      let currentUserInfo = userInfoParam || userInfo;
      
      // Hala userInfo yoksa, fetch et
      if (!currentUserInfo || Object.keys(currentUserInfo).length === 0) {
        currentUserInfo = await fetchUserInfo();
      }

      // Hala userInfo yoksa, cihazları yükleme
      if (!currentUserInfo || Object.keys(currentUserInfo).length === 0) {
        setBedData([]);
        setSameSuit([]);
        return;
      }

      const response = await fetch(`https://app.vivasmartcare.com/api/devices`);
      const devices = await response.json();
      let lastDevices;

      if (currentUserInfo?.company !== "all") {
        // Önce şirket bazlı filtreleme
        let companyDevices = devices.filter(
          (device) => device.organization === currentUserInfo?.company
        );
        console.log("Şirket cihazları:", companyDevices);

        try {
          const deviceResponse = await fetch(
            `https://app.vivasmartcare.com/api/login/${currentUserInfo?.username}`
          );
          const deviceData = await deviceResponse.json();
          console.log("Kullanıcıya atanmış cihazlar:", deviceData);

          // Eğer kullanıcıya atanmış cihazlar varsa, sadece onları filtrele
          if (deviceData[0]?.devices && deviceData[0].devices.length > 0) {
            lastDevices = companyDevices.filter((device) =>
              deviceData[0].devices.includes(device.deviceID)
            );
          } else {
            // Atanmış cihaz yoksa, şirketin tüm cihazlarını göster
            lastDevices = companyDevices;
          }
        } catch (error) {
          console.error("Error fetching device data:", error);
          lastDevices = companyDevices;
        }
      } else {
        lastDevices = devices; // "all" yetkisi varsa tüm cihazlar
      }

      setBedData(lastDevices);

      const groupedData = lastDevices?.reduce((acc, item) => {
        const { suiteName } = item;
        if (suiteName) {
          if (!acc[suiteName]) {
            acc[suiteName] = [];
          }
          acc[suiteName].push(item);
        }
        return acc;
      }, {});

      setSameSuit(
        Object.keys(groupedData).map((suiteName) => ({
          suiteName,
          items: groupedData[suiteName],
        }))
      );
    } catch (error) {
      console.error("Veri getirilirken bir hata oluştu:", error);
    }
  };

  // İlk yüklemede userInfo'yu fetch et
  useEffect(() => {
    fetchUserInfo();
  }, []);

  // userInfo değiştiğinde cihazları getir
  useEffect(() => {
    if (userInfo && Object.keys(userInfo).length > 0) {
      getDevices(userInfo);
    }
  }, [userInfo?.id, userInfo?.company]); // Sadece id ve company değiştiğinde tekrar çağır

  useEffect(() => {
    getUsernames();

    const brokerUrl =
      //"wss://320b1fdf041d4d74ab162229af8aecb9.s1.eu.hivemq.cloud:8884/mqtt";
      "wss://1e58bdad99464d9291251b11ad93b1a6.s2.eu.hivemq.cloud:8884/mqtt";
    const options = {
      //username: "hivemq.webclient.1701086780574",
      username: "hobanew",
      //password: "qB3e@b9ZfCKL.6c;!F2l",
      password: "hobanewAa0",
    };

    const client = mqtt.connect(brokerUrl, options);

    client.on("connect", () => {
      const topics = bedData
        .filter((device) => !checkedItems.includes(device.deviceID))
        .flatMap((device) => [
          `/devices/${device.deviceID}/events`,
          `/devices/${device.deviceID}/state`,
          `hobacare/`,
        ]);

      topics.map((top) => {
        client.subscribe(top, (err) => {
          if (!err) {
            console.log("MQTT bağlantısı başarılı");
          } else {
            console.error(
              `"${top}" konusuna abone olunurken bir hata oluştu: ${err}`
            );
          }
        });
      });
    });

    client.on("error", (error) => {
      console.error("MQTT bağlantı hatası:", error);
    });

    client.on("message", (topic, message) => {
      var alert = JSON.parse(message.toString("utf-8"));

      if (alert && typeof alert === "object" && "header" in alert) {
        if (
          alert?.payload?.heartbreath ||
          alert?.payload?.position ||
          alert?.payload?.hbstatics
        ) {
          const deviceCode = alert?.payload?.deviceCode;
          
          if (deviceCode) {
            // Her cihaz için ayrı veri sakla
            setHobaData((prev) => ({
              ...prev,
              [deviceCode]: {
                payload: {
                  ...prev[deviceCode]?.payload,
                  ...alert.payload,
                },
              },
            }));
          }

          const postureMap = {
            0: "Initialization",
            1: "Walking",
            2: "Suspected fall",
            3: "Squatting",
            4: "Standing",
            5: "Fall confirmation",
            6: "Lying down",
            7: "Suspected sitting on the ground",
            8: "Confirmed sitting on the ground",
            9: "Sitting up on the ordinary bed",
            10: "Suspected sitting up on the bed",
            11: "Confirmed sitting up on the bed",
          };

          const eventMap = {
            0: "No event",
            1: "Enter room",
            2: "Leave room",
            3: "Enter area",
            4: "Leave area",
          };

          if (alert?.payload?.position) {
            const decoded = atob(alert.payload.position);
            const bytes = new Uint8Array(decoded.length);
            for (let i = 0; i < decoded.length; i++) {
              bytes[i] = decoded.charCodeAt(i);
            }

            const people = [];
            for (let i = 0; i < bytes.length; i += 16) {
              const segment = bytes.slice(i, i + 16);

              const postureCode = segment[13];
              const eventCode = segment[14];

              const hobaAlarm = {
                targetId: segment[0],
                x: segment[1] > 127 ? segment[1] - 256 : segment[1],
                y: segment[2] > 127 ? segment[2] - 256 : segment[2],
                z: segment[3],
                timeLeft: segment[12],
                posture: postureMap[postureCode] ?? `Unknown (${postureCode})`,
                event: eventMap[eventCode] ?? `Unknown (${eventCode})`,
                regionId: segment[15],
                deviceId: alert?.payload?.deviceCode,
                time: new Date().toISOString(),
                title: eventMap[eventCode] ?? "Unknown",
              };

              people.push(hobaAlarm);

              // 🔔 Alarm tetikleme fonksiyonu
              const triggerAlarm = async (alarmMessage, description, eventTypeOverride = null) => {
                try {
                  const audio = new Audio(
                    "https://assets.mixkit.co/active_storage/sfx/861/861-preview.mp3"
                  );

                  const response = await fetch(`https://app.vivasmartcare.com/api/devices`);
                  const alarmDevices = await response.json();

                  const alarmDevice = alarmDevices.find(
                    (device) => device.deviceID === hobaAlarm.deviceId
                  );

                  console.log("Alarm verisi alındı:", alarmDevice, hobaAlarm);

                  userInfoCompany = await fetchUserInfo();

                  if (
                    alarmDevice &&
                    (userInfoCompany?.company === "all" ||
                      alarmDevice.organization === userInfoCompany?.company)
                  ) {
                    audio.play();
                    setHobaModa(true);
                    setAlarm({ alarmMessage, alarmDevice });
                  } else {
                    console.warn("Eşleşme yok");
                  }

                  addAlarmLog({
                    deviceId: hobaAlarm.deviceId,
                    endTimestamp: hobaAlarm.time,
                    eventType: eventTypeOverride || hobaAlarm.title,
                    resolved: "false",
                    callCount: "",
                    confirmation: "",
                    description,
                    alarmScenario: "",
                    person: "",
                    auto: "false",
                  });
                } catch (error) {
                  console.error("Alarm tetikleme hatası:", error);
                }
              };

              // 1️⃣ Event tabanlı alarm
              switch (hobaAlarm.event) {
                case "Enter room":
                  triggerAlarm(
                    " kişinin odaya girdiğine ",
                    "Enter room event tespit edildi."
                  );
                  break;
                case "Leave room":
                  triggerAlarm(
                    " kişinin odadan çıktığına ",
                    "Leave room event tespit edildi."
                  );
                  break;
                case "Enter area":
                  triggerAlarm(
                    " kişinin yatağa girdiğine ",
                    "Enter area event tespit edildi."
                  );
                  break;
                case "Leave area":
                  triggerAlarm(
                    " kişinin yataktan çıktığına ",
                    "Leave area event tespit edildi."
                  );
                  break;
                default:
                  break;
              }

              // 2️⃣ Posture tabanlı düşme alarmı
              if (
                ["Suspected fall", "Fall confirmation"].includes(
                  hobaAlarm.posture
                )
              ) {
                // Düşme alarmı için eventType'ı posture'a göre ayarla
                const fallEventType = hobaAlarm.posture === "Suspected fall" 
                  ? "Suspected fall" 
                  : "Fall confirmation";
                triggerAlarm(
                  " kişinin düştüğüne ",
                  "Düşme olayı tespit edildi.",
                  fallEventType
                );
              }
            }
          }
        }
      } else {
        setTopic(topic);

        const parts = topic.split("/");
        const lastPart = parts[parts.length - 1];

        const deviceIDToCheck = parts[2];
        let matchFound = false;

        bedData?.map((device) => {
          if (device.deviceID === deviceIDToCheck) {
            matchFound = true;
          }
        });

        if (matchFound) {
          if (lastPart === "state") {
            setStates(alert);
            // addVayyarLog(deviceIDToCheck, alert, "state");
          } else if (lastPart === "events") {
            setEvents(alert);
            // addVayyarLog(deviceIDToCheck, alert, "event");
            if (alert.status === "calling") {
              var audio = new Audio(
                "https://assets.mixkit.co/active_storage/sfx/861/861-preview.mp3"
              );
              audio.play();

              fetch("https://app.vivasmartcare.com/api/devices")
                .then((response) => {
                  if (!response.ok) {
                    throw new Error("Network response was not ok");
                  }
                  return response.json();
                })
                .then((data) => {
                  const targetPhone = data?.find(
                    (item) => item.deviceID === alert.deviceId
                  );
                  sendSMS(
                    targetPhone.smsPhone,
                    targetPhone.roomName,
                    targetPhone.organization,
                    targetPhone.suiteName
                  )
                    .then(console.log("Sms gönderildi " + targetPhone.smsPhone))
                    .then(setModalShow(true));
                })
                .catch((error) => {
                  console.error(
                    "There was a problem with the fetch operation:",
                    error
                  );
                });
            }
          }
        }
      }
    });
  }, [bedData, checkedItems]);

  // For Vital
  const fetchDevices = async (token) => {
    const url = "https://eu.vitalerter.com/api/v1/devices";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setDevices(data);
    } catch (error) {
      console.error("Cihazlar getirilirken hata oluştu:", error);
      return;
    }

    try {
      const newConnection = new signalR.HubConnectionBuilder()
        .withUrl("https://eu.vitalerter.com/signalr/notification/hub", {
          accessTokenFactory: () => {
            if (!token) {
              throw new Error("Access token is missing!");
            }
            return token;
          },
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
          withCredentials: false,
        })
        .withAutomaticReconnect()
        .configureLogging(signalR.LogLevel.Debug)
        .build();

      newConnection.onclose((error) => {
        console.log("Bağlantı kapandı:", error);
      });

      await newConnection.start();

      newConnection.on("receiveResidentMovementLevelChanged", (message) => {
        try {
          console.log(
            "receiveResidentBedStatusChanged verisi alındı:",
            message
          );
          console.log(message);
        } catch (error) {
          console.error(
            "Error processing receiveResidentBedStatusChanged message:",
            error
          );
        }
      });

      newConnection.on("receiveAlert", async (message) => {
        try {
          console.log("Alarm verisi alındı:", message);
          var audio = new Audio(
            "https://assets.mixkit.co/active_storage/sfx/861/861-preview.mp3"
          );

          const response = await fetch(`https://app.vivasmartcare.com/api/devices`);
          const alarmDevices = await response.json();

          const alarmDevice = alarmDevices.find(
            (device) => device.deviceID === message.deviceId
          );

          if (
            alarmDevice &&
            (userInfoCompany?.company === "all" ||
              alarmDevice.organization === userInfoCompany?.company)
          ) {
            audio.play();
            setVitalModal(true);
            setAlarm(message);
          }

          addAlarmLog({
            deviceId: message.deviceId,
            endTimestamp: message.time,
            eventType: message.title,
            resolved: "false",
            callCount: "",
            confirmation: "",
            description: "",
            alarmScenario: "",
            person: "",
          });
        } catch (error) {
          console.error("Error processing receiveAlert message:", error);
        }
      });

      newConnection.on("receiveDeviceState", (message) => {
        try {
          const parsedMessage = JSON.parse(message.value);
          if (
            parsedMessage &&
            typeof parsedMessage === "object" &&
            parsedMessage.hasOwnProperty("HR") &&
            parsedMessage.HR !== undefined &&
            parsedMessage.HR !== null
          ) {
            parsedMessage.deviceId = message.deviceId;
            setMessages((prevMessages) => [...prevMessages, parsedMessage]);
          } else if (message.type === "BatteryLevel") {
            setBattery((prevBattery) => [...prevBattery, message]);
          } else {
          }
        } catch (error) {
          console.error("Error parsing message or updating state:", error);
        }
      });

      setConnection(newConnection);
    } catch (error) {
      console.error("SignalR hatası:", error);
    }
  };

  useEffect(() => {
    const authenticate = async () => {
      const jwtToken =
        "/9m2n37CxCoGq9wVW1Sm1+tMsZHhPgPoay2eESkrPpY28apaCXhP1yCQY9fhks4H";
      const url =
        "https://eu.vitalerter.com/api/v1/organizations/apiaccess/authenticate";

      try {
        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${jwtToken}`,
          },
          body: JSON.stringify({ apiKey: jwtToken }),
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
      } catch (error) {
        console.error("Error during authentication:", error);
      }
    };

    authenticate().then((token) => {
      fetchDevices(token);
      setVitalToken(token);
    });
  }, []);
  // For Vital

  return (
    <DasboardContext.Provider
      value={{
        isLogin,
        setIsLogin,
        sidebarOpen,
        setSidebarOpen,
        profileName,
        setProfileName,
        bedData,
        topic,
        states,
        events,
        usernames,
        userInfo,
        setUserInfo,
        sameSuit,
        checkedItems,
        setCheckedItems,
        filter,
        setFilter,
        messages,
        battery,
        hobaData,
        vitalToken,
      }}
    >
      <Modal show={modalShow}>
        <Modal.Header>Bir bildirim aldınız!</Modal.Header>
        <Modal.Body className="device-add-wrapper">
          <p>Bir düşme bildirimi aldınız!</p>
          <div className="button-wrapper">
            <Button
              variant="secondary"
              onClick={() => {
                setModalShow(false);
                const currentPath = window.location.pathname;
                if (currentPath === "/" || currentPath === "/homepage") {
                window.location.reload();
                }
              }}
            >
              Kapat
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={vitalModal}>
        <Modal.Header>Bir bildirim aldınız!</Modal.Header>
        <Modal.Body className="device-add-wrapper">
          <p>
            {alarm?.room} adlı odada bulunan {alarm?.patientName} adlı
            kullanıcıdan{" "}
            {alarm?.typeId === "inBed"
              ? "yatağa girdiğine"
              : alarm?.typeId === "outOfBed"
              ? "yataktan çıktığına"
              : alarm?.typeId === "awayFromBed"
              ? "yataktan uzakta olduğuna"
              : alarm?.typeId === "bp"
              ? "tansiyon durumuna"
              : alarm?.typeId === "bt"
              ? "vücut sıcaklığına"
              : alarm?.typeId === "callButton"
              ? "aranma"
              : alarm?.typeId === "fall"
              ? "düşme önleme durumuna"
              : alarm?.typeId === "falldetected"
              ? "düşme durumuna"
              : alarm?.title === "Low Heart Rate"
              ? "düşük kalp atış hızına"
              : alarm?.title === "Posture Change"
              ? "pozisyon hatırlatma durumuna"
              : alarm?.title === "High Heart Rate"
              ? "yüksek kalp atış hızına"
              : alarm?.title === "Low Respiration Rate"
              ? "düşük solunum hızına"
              : alarm?.title === "High Respiration Rate"
              ? "yüksek solunum hızına"
              : alarm?.typeId === "head"
              ? "epilepsinin tespit edildiğine"
              : alarm?.typeId === "spo"
              ? "oksijen strasyonuna"
              : alarm?.typeId === "tback"
              ? "bası yarası hatırlatmasına"
              : alarm?.typeId === "tleft"
              ? "bası yarası hatırlatmasına"
              : alarm?.typeId === "tright"
              ? "bası yarası hatırlatmasına"
              : ""}{" "}
            dair bildirim aldınız.
          </p>
          <div className="button-wrapper">
            <Button
              variant="secondary"
              onClick={() => {
                setVitalModal(false);
                const currentPath = window.location.pathname;
                console.log(currentPath);
                if (currentPath === "/" || currentPath === "/homepage") {
                  window.location.reload();
                }
              }}
            >
              Kapat
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={hobaModal}>
        <Modal.Header>Bir bildirim aldınız!</Modal.Header>
        <Modal.Body className="device-add-wrapper">
          <p>
            {alarm.alarmDevice?.organization} kurumuna bağlı{" "}
            {alarm.alarmDevice?.roomName} adlı odadan
            {alarm.alarmMessage} dair bildirim aldınız!
          </p>
          <div className="button-wrapper">
            <Button
              variant="secondary"
              onClick={() => {
                setHobaModa(false);
                const currentPath = window.location.pathname;
                if (currentPath === "/" || currentPath === "/homepage") {
                window.location.reload();
                }
              }}
            >
              Kapat
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {children}
    </DasboardContext.Provider>
  );
};

export { DasboardContext, DashboardProvider };
